import { render } from "./contacts-table.vue?vue&type=template&id=cc091b6c"
import script from "./contacts-table.vue?vue&type=script&lang=js"
export * from "./contacts-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__